import YFTableColumn from './index.vue'

YFTableColumn.install = (Vue, options) => {
    Vue.prototype.$ELEMENT = options
    Vue.component(YFTableColumn.name, YFTableColumn)
}

export default YFTableColumn
